import React from "react";
import UseLang from "../../../hooks/UseLang";

function EvolucionGlobalRPKIPreview() {
  return (
    <>
      <div class="alerts alert_white">
        <UseLang es pt> 
        <h1>Evolución global y regional de la adopción de RPKI </h1>
          <p>
            <strong> Autor:</strong> Erika Vega – chair grupo de trabajo
            enrutamiento lacnog
          </p>
         
          <p>
            <strong>Coordinación:</strong> Guillermo Cicileo
          </p>
        
          <p>
            <strong>Área:</strong> i+d en infraestructura de internet
          </p>
         
          <p>
            <strong>Fecha:</strong> 31/08/2025
          </p>
         
          <a
            href="/es/interconexion/evolucion-global-y-regional-de-la-adopcion-de-rpki"
            class="buttons button_blue" 
          >
            Leer Reporte
          </a>
          </UseLang>
          <UseLang en> 
          <h1>Global and regional evolution of RPKI adoption </h1>
            <p>
              <strong> Author:</strong> Erika Vega – chair grupo de trabajo
              enrutamiento lacnog
            </p>
          
            <p>
              <strong>Coordination:</strong> Guillermo Cicileo
            </p>
          
            <p>
              <strong>Area:</strong> i+d en infraestructura de internet
            </p>
          
            <p>
              <strong>Date:</strong> 31/08/2025
            </p>
          
            <a
              href="/en/interconnection/global-and-regional-evolution-of-rpki-adoption"
              class="buttons button_blue" 
            >
              Read Report
            </a>
          </UseLang>
         
      </div>
    </>
  );
}

export default EvolucionGlobalRPKIPreview;
